import buttonForCard from './buttonForCard.vue'
export default buttonForCard
